export default __webpack_public_path__ + "static/media/ST1_SPRING_LIFT_550_A.b6494669.cdf279cc.png";